import { MODELS, MODEL_PRICING } from '../data/models';

/* =================================================================
   6b. Cost tracking — public-pricing-based estimate (not real balance)
   Providers do NOT expose account balance via API key. We estimate
   the spend per call from the response's `usage` field × public pricing.
   ================================================================= */

export const spentTracker = JSON.parse(localStorage.getItem("lp_aiboard_spent") || "{}");

export function calcCost(modelId, inTokens, outTokens) {
  const p = MODEL_PRICING[modelId];
  if (!p) return 0;
  return (inTokens / 1e6) * p.in + (outTokens / 1e6) * p.out;
}

export function addSpent(modelId, cost) {
  if (!cost) return;
  spentTracker[modelId] = (spentTracker[modelId] || 0) + cost;
  localStorage.setItem("lp_aiboard_spent", JSON.stringify(spentTracker));
  // Refresh the cost legend (visible after every run)
  // Use a custom event so cost-legend.ts can listen without circular import.
  window.dispatchEvent(new CustomEvent("lp-spent-updated", { detail: { modelId } }));
}

export function getSpent(modelId) {
  return spentTracker[modelId] || 0;
}

export function getTotalSpent() {
  return Object.values(spentTracker).reduce((a, b) => a + b, 0);
}

export function resetSpent() {
  Object.keys(spentTracker).forEach(k => delete spentTracker[k]);
  localStorage.removeItem("lp_aiboard_spent");
  window.dispatchEvent(new CustomEvent("lp-spent-updated", { detail: { modelId: null } }));
}

export function getModelTier(modelId) {
  const p = MODEL_PRICING[modelId];
  if (!p) return 1;
  if (p.free || (p.in === 0 && p.out === 0)) return 0;
  const total = p.in + p.out;
  if (total < 5)  return 1;
  if (total < 15) return 2;
  if (total < 50) return 3;
  return 4;
}

export function getSortedModelsByCost() {
  return [...MODELS].sort((a, b) => {
    const pa = MODEL_PRICING[a.id], pb = MODEL_PRICING[b.id];
    const ca = pa ? pa.in + pa.out : 0;
    const cb = pb ? pb.in + pb.out : 0;
    return ca - cb;
  });
}

export const TIER_LABELS = ["FREE", "$", "$$", "$$$", "$$$$"];
